import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
  } from "redux-persist";
import type { Middleware } from "@reduxjs/toolkit"

import { authApi } from '../Apis/authApi'
import { examApi } from '../Apis/examApi'
import { userExamApi } from '../Apis/userExamApi'
import { bookmarkApi } from '../Apis/bookmarkApi'
import { packageApi } from '../Apis/packageApi'
import { blogApi } from '../Apis/blogApi'
import { referralApi } from '../Apis/referralApi'
import { leitnerApi } from '../Apis/leitnerApi'
import authReducer from '../Slices/authSlice'
import timerReducer from '../Slices/timerSlice';
import directiveReducer from '../Slices/directiveSlice';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    blacklist: [
        authApi.reducerPath,
        examApi.reducerPath,
        userExamApi.reducerPath,
        bookmarkApi.reducerPath,
        packageApi.reducerPath,
        blogApi.reducerPath,
        referralApi.reducerPath,
        leitnerApi.reducerPath,
    ],
}

const appReducer = combineReducers({
    auth: authReducer,
    timers: timerReducer,
    dir: directiveReducer,
    [authApi.reducerPath]: authApi.reducer,
    [examApi.reducerPath]: examApi.reducer,
    [userExamApi.reducerPath]: userExamApi.reducer,
    [bookmarkApi.reducerPath]: bookmarkApi.reducer,
    [packageApi.reducerPath]: packageApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
    [referralApi.reducerPath]: referralApi.reducer,
    [leitnerApi.reducerPath]: leitnerApi.reducer,
})

const reducerProxy = (state: ReturnType<typeof appReducer> | undefined, action: AnyAction) => {
    if(action.type === 'USER_LOGOUT') {
        storage.removeItem('persist:root');
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
}

const persistedReducer = persistReducer(persistConfig, reducerProxy)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]},
        }).concat([
            authApi.middleware,
            examApi.middleware,
            userExamApi.middleware,
            bookmarkApi.middleware,
            packageApi.middleware,
            blogApi.middleware,
            referralApi.middleware,
            leitnerApi.middleware,
        ] as Middleware[]),
    devTools: false,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const persistor = persistStore(store)
